import { BusMessage, calcStringByteLength, MessageFactory } from "flavr-common";
export class StartAnalyticsMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.clientId);
    }
    constructor(clientId) {
        super();
        this.clientId = clientId;
    }
    serialization(stream) {
        this.clientId = stream.utf16String(this.clientId);
    }
    static is(msg) {
        return msg.type === StartAnalyticsMessage.typestatic;
    }
}
StartAnalyticsMessage.typestatic = "StartAnalyticsMessage";
StartAnalyticsMessage.subjectstatic = "general";
MessageFactory.register(StartAnalyticsMessage);
export class StopAnalyticsMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.clientId) + calcStringByteLength(this.fileId);
    }
    constructor(clientId, fileId) {
        super();
        this.clientId = clientId;
        this.fileId = fileId;
    }
    serialization(stream) {
        this.clientId = stream.utf16String(this.clientId);
        this.fileId = stream.utf16StringSafe(this.fileId);
    }
    static is(msg) {
        return msg.type === StopAnalyticsMessage.typestatic;
    }
}
StopAnalyticsMessage.typestatic = "StopAnalyticsMessage";
StopAnalyticsMessage.subjectstatic = "general";
MessageFactory.register(StopAnalyticsMessage);
